export function numberToFixedDecimals (value: number, decimals: number, multiplyResultParseFunc) {
	return (Math.ceil(parseInt(multiplyResultParseFunc(value * Math.pow(10, decimals)))) / Math.pow(10, decimals)).toFixed(decimals);
}
